//eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'light',
  colors: {
    primary: '#2C858D',
    primary_100: '#2c858d0a',
    secondary: '#004056',
    background: '#F1F1F1',
    background_white: '#fff',
    text: '#707070',
    error_200: '#ffe5e5',
    error: '#B10000',
    error_500: '#D51226',
    tertiary: '#e5ffee',
    tertiary_500: '#74CEB7',
    tertiary_800: '#2BA9AB',
    tertiary_300: '#C9FFD5',
    text_gray: '#8A8A8A',
    gray: '#8D8D8D',
    gray_200: '#F8F8F8',
    gray_250: '#EBEBEB',
    gray_275: '#ABABAB',
    gray_300: '#5A5A5A',
    yellow: '#ffffcb',
    yellow_200: '#FFFFCB',
    blue_200: '#BAEBFE',
    blue: '#293778',
    black: '#434343',
    transparent: 'transparent',
  },
};
